module.exports = __webpack_public_path__ + "img/c05_unitcenturion_Normal_ua.cf0b9559.webp";